module.exports = __webpack_public_path__ + "static/media/dispatch_systemmoduleD-img1.9b409483.png";